import { MobiUiLanguage } from '@mobi/rwc-ui-components-ng-jslib';

import { AppSource } from '../../common.constant';

export interface Links {
    dataProtection: string;
    instruction: string;
    imprint: string;
    legalInfo: string;
    contactAndFeedback: string;
    notFoundPageOverview: string;
    notFoundPageOverviewRedNet: string;
    notFoundPageContact: string;
    notFoundPageCustomerPortal: string;
    mobiliarLegalAdviser: string;
}

export type LinksMap = Record<MobiUiLanguage, Record<AppSource, Links>>;

export const linksMap: LinksMap = {
    de: {
        Mobiliar: {
            dataProtection: 'https://www.mobiliar.ch/datenschutz',
            instruction: '',
            imprint: 'https://www.mobiliar.ch/impressum',
            legalInfo: 'https://www.mobiliar.ch/rechtliches',
            contactAndFeedback: 'https://www.mobiliar.ch/kontakt',
            notFoundPageOverview: 'https://mobiliar.ch/avb',
            notFoundPageOverviewRedNet:
                'https://services.marketing.mobiliar.ch/de/downloads/e-bibliothek?list.filter=%7B%22mobi:mawi.productgroup%22:%5B%22root.avb.%22%5D,%22censhare:asset.language%22:%5B%22de%22%5D%7D&s.text=&m.fset=true',
            notFoundPageContact: 'https://www.mobiliar.ch/kontakt',
            notFoundPageCustomerPortal: 'https://www.mobiliar.ch/login',
            mobiliarLegalAdviser: 'https://www.mobiliar.ch/thema/rechtsratgeber',
        },
        Protekta: {
            dataProtection: 'https://protekta.mobiliar.ch/datenschutz',
            instruction: '',
            imprint: 'https://protekta.mobiliar.ch/impressum',
            legalInfo: 'https://protekta.mobiliar.ch/rechtliche-hinweise',
            contactAndFeedback: 'https://protekta.mobiliar.ch/jurline',
            notFoundPageOverview:
                'https://protekta.mobiliar.ch/rechtliche-hinweise/allgemeine-versicherungsbedingungen',
            notFoundPageOverviewRedNet:
                'https://services.marketing.mobiliar.ch/de/downloads/e-bibliothek?m.fset=true&s.text=&list.filter=%7B%22mobi:mawi.productgroup%22:%5B%22root.avb.%22%5D,%22censhare:asset.language%22:%5B%22de%22%5D,%22mobi:mawi.material%22:%5B%22root.protekta-rechtsschutz.%22%5D%7D',
            notFoundPageContact: 'https://protekta.mobiliar.ch/jurline',
            notFoundPageCustomerPortal: 'https://www.mobiliar.ch/login',
            mobiliarLegalAdviser: 'https://www.mobiliar.ch/thema/rechtsratgeber',
        },
    },
    fr: {
        Mobiliar: {
            dataProtection: 'https://www.mobiliere.ch/protection-des-donnees',
            instruction: '',
            imprint: 'https://www.mobiliere.ch/impressum',
            legalInfo: 'https://www.mobiliere.ch/aspect-juridique',
            contactAndFeedback: 'https://www.mobiliere.ch/contact',
            notFoundPageOverview: 'https://www.mobiliere.ch/cga',
            notFoundPageOverviewRedNet:
                'https://services.marketing.mobiliere.ch/fr/downloads/e-bibliotheque?m.fset=true&s.text=&list.filter=%7B%22mobi:mawi.productgroup%22:%5B%22root.avb.%22%5D,%22censhare:asset.language%22:%5B%22fr%22%5D%7D',
            notFoundPageContact: 'https://www.mobiliere.ch/contact',
            notFoundPageCustomerPortal: 'https://www.mobiliere.ch/login',
            mobiliarLegalAdviser: 'https://www.mobiliere.ch/theme/guide-juridique',
        },
        Protekta: {
            dataProtection: 'https://protekta.mobiliere.ch/securite-et-protection-de-donnees',
            instruction: '',
            imprint: 'https://protekta.mobiliere.ch/impressum',
            legalInfo: 'https://protekta.mobiliere.ch/aspect-juridique',
            contactAndFeedback: 'https://protekta.mobiliere.ch/jurline',
            notFoundPageOverview: 'https://protekta.mobiliere.ch/aspect-juridique/conditions-generales-d-assurance',
            notFoundPageOverviewRedNet:
                'https://services.marketing.mobiliere.ch/fr/downloads/e-bibliotheque?s.text=&list.filter=%7B%22mobi:mawi.productgroup%22:%5B%22root.avb.%22%5D,%22censhare:asset.language%22:%5B%22fr%22%5D,%22mobi:mawi.material%22:%5B%22root.protekta-rechtsschutz.%22%5D%7D&m.fset=true',
            notFoundPageContact: 'https://protekta.mobiliere.ch/jurline',
            notFoundPageCustomerPortal: 'https://www.mobiliere.ch/login',
            mobiliarLegalAdviser: 'https://www.mobiliere.ch/theme/guide-juridique',
        },
    },
    it: {
        Mobiliar: {
            dataProtection: 'https://www.mobiliare.ch/protezione-dei-dati',
            instruction: '',
            imprint: 'https://www.mobiliare.ch/impressum',
            legalInfo: 'https://www.mobiliare.ch/aspetti-giuridici',
            contactAndFeedback: 'https://www.mobiliare.ch/contatto',
            notFoundPageOverview: 'https://mobiliare.ch/cga',
            notFoundPageOverviewRedNet:
                'https://services.marketing.mobiliere.ch/fr/downloads/e-bibliotheque?list.filter=%7B%22mobi:mawi.productgroup%22:%5B%22root.avb.%22%5D,%22censhare:asset.language%22:%5B%22it%22%5D%7D&s.text=&m.fset=true',
            notFoundPageContact: 'https://www.mobiliare.ch/contatto',
            notFoundPageCustomerPortal: 'https://www.mobiliare.ch/login',
            mobiliarLegalAdviser: 'https://www.mobiliare.ch/tema/guida-giuridica',
        },
        Protekta: {
            dataProtection: 'https://protekta.mobiliare.ch/sicurezza-e-protezione-dei-dati',
            instruction: '',
            imprint: 'https://protekta.mobiliare.ch/impressum',
            legalInfo: 'https://protekta.mobiliare.ch/aspetti-giuridici',
            contactAndFeedback: 'https://protekta.mobiliare.ch/jurline',
            notFoundPageOverview:
                'https://protekta.mobiliare.ch/aspetti-giuridici/condizioni-generali-di-assicurazione',
            notFoundPageOverviewRedNet:
                'https://services.marketing.mobiliere.ch/fr/downloads/e-bibliotheque?s.text=&list.filter=%7B%22mobi:mawi.productgroup%22:%5B%22root.avb.%22%5D,%22censhare:asset.language%22:%5B%22fr%22%5D,%22mobi:mawi.material%22:%5B%22root.protekta-rechtsschutz.%22%5D%7D&m.fset=true',
            notFoundPageContact: 'https://protekta.mobiliare.ch/jurline',
            notFoundPageCustomerPortal: 'https://www.mobiliare.ch/login',
            mobiliarLegalAdviser: 'https://www.mobiliare.ch/tema/guida-giuridica',
        },
    },
    en: {
        Mobiliar: {
            dataProtection: '',
            instruction: '',
            imprint: '',
            legalInfo: '',
            contactAndFeedback: '',
            notFoundPageOverview: '',
            notFoundPageOverviewRedNet: '',
            notFoundPageContact: '',
            notFoundPageCustomerPortal: '',
            mobiliarLegalAdviser: '',
        },
        Protekta: {
            dataProtection: '',
            instruction: '',
            imprint: '',
            legalInfo: '',
            contactAndFeedback: '',
            notFoundPageOverview: '',
            notFoundPageOverviewRedNet: '',
            notFoundPageContact: '',
            notFoundPageCustomerPortal: '',
            mobiliarLegalAdviser: '',
        },
    },
};
